var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnArrowBack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1758 4.92578V6.07422H3.06641L6.32031 9.35547L5.5 10.1758L0.824219 5.5L5.5 0.824219L6.32031 1.64453L3.06641 4.92578H10.1758Z",
    fill: "#007BFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnArrowBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-arrow-back.b07f3f8c.svg";
export { ForwardRef as ReactComponent };